import { animated, config, useSpring } from '@react-spring/web';
import { memo } from 'react';

import { Exclamation } from '@air/next-icons';

export const FileStatusIconStopped = memo(() => {
  const [props] = useSpring(
    () => ({
      config: config.wobbly,
      from: { scale: 0 },
      to: { scale: 1 },
    }),
    [],
  );

  return (
    <div aria-hidden className="mr-3 flex size-10 items-center justify-center rounded-full bg-yellow-3">
      <animated.div className="flex items-center justify-center" style={props}>
        <Exclamation className="size-6 fill-yellow-9" />
      </animated.div>
    </div>
  );
});

FileStatusIconStopped.displayName = 'FileStatusIconStopped';
